import { getRouterPage, toNext } from './router.map.js';
import bdoStepRaw from "../bdostep.map"
import API from "@/api"
import allFields from "./forms/allFields.json";
import {
  acquirerOptions,
  bankOptions,
  citizenShipOptions,
  civilStatusOptions,
  idTypeOptions,
  sourceOfFundsOptions,
  yearsNumberOptions
} from "@/locales/select-data"
import { businessDescriptionABData, provinceData, cityData } from "@/common-data/config.js"
// import citSelectyData from "@/common-data/city_select_data";
import barangayData from "@/common-data/barangay-data";
import { onlineServiceOn, BDOCHECKOUTURL } from '@/config.js';
import CookieHelper from '@/plugins/cookie.js';
import BdoProcessMap from '@/bdo.process.map.js';
import { getPageNoKey } from '@/bdo.process.map.js';

import fieldsInfo from '@/pc/forms/allFields.json';
import { Loading } from 'element-ui';

const { formRules } = require('./forms/all.form.validate.js');

const bdostep = Object.keys(bdoStepRaw).reduce((acc, item) => {
  const { pageNo, processNo } = bdoStepRaw[item];
  acc[item] = {
    pageNo,
    processNo,
  }

  return acc;
}, {});

let loadingInstance = null;

// 将数据写到缓存
export const writeToCache = (key, data) => {
  window.localStorage.setItem(key, JSON.stringify(data))

  return true;
}

// 读取缓存数据
export const readFromCache = (key) => {

  return JSON.parse(window.localStorage.getItem(key));
};

// 存储bdoStepData(内存数据)
const setBDOStepData = (step, data) => {
  stepData[step] = data;
  // 敏感数据, 特殊数据可以放到stepBlackList中
  const stepBlackList = [
    'mchPd', // 临时密码
  ];
  // stepBlackList名单中的字段不会写到缓存中, 页面刷新后会丢失
  if (stepBlackList.indexOf(step) === -1) {
    writeToCache(step, data);
  }

  return true;
};

// 获取bdoStepData
const getBDOStepData = (step) => {
  const data = stepData[step] || readFromCache(step);

  return data;
};

const stepData = { ...bdostep };

export default (Vue) => {
  Vue.mixin({
    data() {
      return {
        wallytMode: onlineServiceOn,// wallyt模式, 控制一下只在公司环境做的操作
        isEdit: false,
        detailApi: API.getPageInfo,// 单页面获取详情接口API
        fromSummary: null,         // 是否从总详情返回参数
        normalBackward: null,      // 是否来自上一步详情
        pageMode: "add",           // ButtonBottom 组件  mode参数
        dataId: 0,                 // 编辑时的步骤的详情id,
        flowPage: false,           // 为true时, 会调用mixin中的created钩子
        formRules: formRules       // 表单验证规则
      }
    },
    // mixin中的钩子会混入每个组件,并在组件内的created钩子之前调用
    // 所有增加flowPage参数来作为开关参数
    created() {
      const { mode, fromSummary } = (this.$route && this.$route.query) || {};
      if (this.flowPage && ((mode === 'edit') || fromSummary)) {
        this.pageMode = mode;
        this.loadDetail();
        this.fromSummary = fromSummary;
      }
    },
    mounted() {
      this.getPageData()
      this.isShowDialog()
    },
    // 使用组件内路由钩子处理普通后退操作
    beforeRouteEnter(to, from, next) {
      const isDev = process.env.NODE_ENV === 'development'
      const userAgent = navigator.userAgent.toLowerCase();
      if(userAgent.match(/(phone|pad|pod|iphone|ipod|ios|ipad|android|mobile|blackberry|iemobile|mqqbrowser|juc|fennec|wosbrowser|browserng|webos|symbian|windows phone|windows mobile|windows ce|ucweb|rv:1.2.3.4|midp)/i)){
        window.location.href = isDev ? `${window.location.origin}/h5-index/${window.location.hash}`
                                     : `${window.location.origin}/signup/moblie-index.html${window.location.hash}`
        return
      }
      next(vm => {
        // 通过 `vm` 访问组件实例
        // vm.updateFlowStep();
        const { fromSummary } = (vm.$route && vm.$route.query) || {};
        if (!fromSummary && vm.flowPage && vm.compareToFlowStep()) {
          vm.pageMode = "edit";
          vm.loadDetail();
        }
        // console.log(vm);
      });
    },
    methods: {
      // 获取当前页数据回写
      getPageData() {
        const { key = '', pageNo = '' } = getPageNoKey(this.$options.name)
        const keyMap = {
          '1': 'digitalPaymentList',
          '2': 'physicalPaymentList',
        }
        const formMap = ['3','4','5','6','10','15']
        const listMap = ['8','9']
        if (key) {
          const data = this.formatCommitData({})
          API.getBdoProcessData({
            ...data
          }).then(res => {
            if(!(key in res.obj)) {
              return
            }
            if (keyMap[pageNo]) {
              this.formData = res.obj[key][keyMap[pageNo]]
            } else if (formMap.includes(pageNo)) {
              this.formData = res.obj[key]
              this.$refs.appForm.updateDataForm && this.$refs.appForm.updateDataForm(res.obj[key]);
            } else if (listMap.includes(pageNo)) {
              this.$refs.appForm.updateDataForm && this.$refs.appForm.updateDataForm(res.obj[key]);
            } else {
              this.formData = res.obj[key]
            }
            if (pageNo == '6') {
              this.sameAasHomeAddress = res.obj[key].sameAasHomeAddress
            }
            if (pageNo == '4') {
              this.formData = res.obj[key]
              this.formData.birthday = `${res.obj[key].year}-${res.obj[key].month}-${res.obj[key].day}`;
              this.$refs.appForm.updateDataForm && this.$refs.appForm.updateDataForm(this.formData);
            }
            if (this.$options.name == 'BdoMerchantA') {
              let data = res.obj[key]
              data['city_1'] = data.city
              data['businessName_1'] = data.businessName
              this.formData = data
              this.$refs.appForm.updateDataForm && this.$refs.appForm.updateDataForm(data);
            }
            if (this.$options.name == 'IndividualF') {
              let data = res.obj[key]
              data['businessName_1'] = data.businessName
              this.formData = data
              this.$refs.appForm.updateDataForm && this.$refs.appForm.updateDataForm(data);
            }
          })
        }
      },
      // 判断是否展示弹窗
      isShowDialog() {
        if(!this.$route) {
          return
        }
        const { type = '', name = '', fullName = '' } = this.$route.params
        const obj = {
          Individual: 'Individual',
          SoleProp: 'Sole Proprietorship',
          Corporation: 'Corporation',
          Partnership: 'Partnership',
          BdoMerchant: 'BDO',
        }
        if(type == 'showDialog' && this.$options.name == name) {
          const body = document.body
          body.style.height = '100%'
          body.style.overflow = 'hidden'
          const mesg = name.substring(0, name.length - 1)
          this.$confirm({
            title: fullName,
            mesg: obj[mesg]
          }).then(() => {
            const body = document.body
            body.style.height = '100%'
            body.style.overflow = 'auto'
          })
        }
      },
      // 展示错误数据弹窗
      showMessageTip(msg) {
        this.$confirm({
          tip: true,
          mesg: msg,
        })
      },
      // 转换下拉列表字段内容
      transformTypeData(field, value, data) {
        const _this = this;
        const typeData = {
          busiNature() {

            return businessDescriptionABData[value].label;
          },
          busiDescript() {

            return businessDescriptionABData[data['busiNature']].services
              .find(item => item.value === value)
              .label;
          },
          settleAccountType() {

            return _this.handleOption(bankOptions, value);
          },
          idType() {

            return _this.handleOption(idTypeOptions, value);
          }
        };

        return typeData[field] ? typeData[field]() : value;
      },
      // 获取字段文案
      getFieldLabel(field) {
        const i18nKey = allFields[field] && allFields[field]['i18nKey'];

        return i18nKey ? this.$t(i18nKey) : field;
      },
      // 判断当前页面是否需要为编辑模式
      compareToFlowStep() {
        const flowStep = this.getStepData("flowStep")["flowStep"];
        const bdoStep = this.getBdoStep();

        return this.sliceBdoStep(flowStep) >= this.sliceBdoStep(bdoStep);
      },
      // 更新dataId
      updateDataId(message) {
        this.dataId = message.id;
        delete message.id;
      },
      // 判断id是否存在并加入formData
      addDataId(formData) {
        if (this.dataId) {
          formData.id = this.dataId;
        }

        return formData;
      },
      // 根据bdoStep获取页面字段配置
      getPageFields(bdoStep) {

        return (bdoStepRaw[bdoStep] || { fields: [] })['fields'];
      },
      // 编辑时获取数据
      loadDetail() {
        const bdoStep = this.getBdoStep();

        if (bdoStep) {
          const stepData = this.getStepData([bdoStep]);
          // eslint-disable-next-line
          // debugger
          API.getPageInfo(stepData).then(res => {
            if (res.result) {
              const { message } = res;
              this.updateDataId(message);
              Object.assign(this.formData, message);
            }
          });
        }
      },
      // 跳到下一步 根据组件配置的 pRouter 和 rIndex来判断
      toNext,

      // 跳转到指定页面
      // option参数, eg: { name: 'AgencyBanking', params: { userId: 123 }}
      toRoute(option) {
        this.$router.push(option)
      },

      // 更新流程数据
      updateStepData(data, key) {
        // eslint-disable-next-line
        const { path, name } = this.$route;
        console.log(getRouterPage(path), data)
        const page = getRouterPage(path);
        const { bdoStep } = page.component;
        // console.log("page.component", page.component)
        console.log("stepData", stepData)
        // stepData[key || bdoStep] = data;
        setBDOStepData(key || bdoStep, data);
        // key &&  stepData[key] = data

      },

      // 获取流程数据
      getStepData(step) {
        const steps = Array.isArray(step) ? step : [step];
        const targetData = steps.reduce((acc, item) => {
          const stepData = getBDOStepData(item);
          Object.assign(acc, stepData);

          return acc;
        }, {});
        const merchantId = getBDOStepData('merchantId');

        return merchantId ? { ...targetData, merchantId } : targetData;
      },

      // 存储merchantId
      setMerchantId(merchantId) {
        merchantId && setBDOStepData('merchantId', merchantId);
      },

      /**
       * APP返回首页
       */
      goBackAppIndex() {
        window.location.href = BDOCHECKOUTURL
      },

      /**
       * APP当前页面截图
       */
      takeAppSrceenShort() {
        this.callAppHandler({ apiCode: 4 })
      },

      /**
       *
       * @param pageStep  总详情 获取对应页面模块的bdostep
       * @param result    总详情返回的数据
       * @returns {*}     返回处理好的数据
       */
      handleDetailData(pageStep, result) {
        return pageStep.reduce((acc, key) => {
          console.log("key", key)
          acc[key] = bdoStepRaw[key]["fields"].reduce((subAcc, subItem) => {

            this.handleData(subItem, result)

            if (result[subItem]) {
              subAcc[[allFields[subItem]["labelTxt"]]] = result[subItem]
            }

            // 手动添加市区, 编码, 为了省市按顺序显示, 放这个位置
            if (subItem === "homeProState") {
              subAcc[[allFields["homeCityMun"]["labelTxt"]]] = result["homeCityMun"]
              subAcc[[allFields["homeZipCode"]["labelTxt"]]] = result["homeZipCode"]
            }

            // 手动添加市区, 编码, 为了省市按顺序显示, 放这个位置
            if (subItem === "busiStoreProState") {
              subAcc[[allFields["busiStoreCityMun"]["labelTxt"]]] = result["busiStoreCityMun"]
              subAcc[[allFields["busiStoreZipCode"]["labelTxt"]]] = result["busiStoreZipCode"]
            }

            return subAcc
          }, {})
          return acc
        }, {})
      },

      /**
       * 处理 下拉框 切换按钮 需要显示的文案
       * @param 传进要处理数据的  key值
       * @param 总详情返回的结果
       */
      handleData(subItem, result) {
        if (subItem === "citizenship") {
          result[subItem] = this.handleOption(citizenShipOptions, result[subItem])
        }

        if (subItem === "civilStatus") {
          result[subItem] = this.handleOption(civilStatusOptions, result[subItem])
        }

        if (subItem === "sourceOfFunds") {
          result[subItem] = this.handleOption(sourceOfFundsOptions, result[subItem])
        }

        if (subItem === "busiNature") {
          result["busiDescript"] = this.handleOption(businessDescriptionABData[result[subItem]]["services"], result["busiDescript"])
        }

        if (subItem === "tinStatus") {
          result[subItem] = this.handleOption(acquirerOptions, result[subItem])
        }

        if (subItem === "yearsNumber") {
          result[subItem] = this.handleOption(yearsNumberOptions, result[subItem] || "1")
        }

        if (subItem === "acquirerStatus") {
          result[subItem] = this.handleOption(acquirerOptions, result[subItem])
        }
      },

      handleOption(arrayObj, value) {
        return arrayObj.filter(item => {
          return item.value === value
        })[0]["label"]
      },

      /**
       *
       * @returns 返回  url 的传参
       */
      getUrlParams() {
        return this.$route.query
      },

      /**
       *每次进页面, 必须在created获取该方法
       */
      isEditDetail(key) {
        let { fromSummary, normalBackward } = this.getUrlParams()

        this.fromSummary = fromSummary
        this.normalBackward = normalBackward

        if (fromSummary || normalBackward) {
          this.isEdit = true
        }
        this.loadPageData(key).then(data => {
          this.onDetailDone(data)
        })
      },

      /**
       * 判断页面是否需要获取详情
       */
      loadPageData(key) {
        return new Promise((res) => {
          const flowStep = this.getStepData("flowStep")["flowStep"]
          const { path } = this.$route;
          const page = getRouterPage(path);
          const { bdoStep } = page.component;
          //最新完成页面 如果大于 当前页, 则获取详情, 否则不获取详情
          if (this.sliceBdoStep(flowStep) >= this.sliceBdoStep(bdoStep)) {
            this.getDetail(key || bdoStep).then(data => {
              this.pageMode = "edit"
              res(data)
            })
          } else {
            res(this.getStepData(key || bdoStep))
          }

        })
      },

      /**
       * 获取页面详情接口
       * @bdoStep  传进 当前页面的 bdoStep
       */
      getDetail(bdoStep) {
        const stepMap = this.getStepData([bdoStep]);
        let submitData = {
          ...stepMap
        }
        return this.detailApi && this.detailApi(submitData)
      },

      /**
       * 获取组件的 bdoStep
       * @returns {返回  当前页面 bdoStep 的值}
       */
      getBdoStep() {
        const { path } = this.$route;
        const page = getRouterPage(path);
        const { bdoStep } = page.component;
        return bdoStep
      },

      /**
       * 每个组件调取详情 都需覆盖该方法, 处理获取详情接口的数据
       * @data  详情接口返回的数据
       */
      onDetailDone(data) {
        console.log({ data })
      },

      /**
       * flowStep: 用来判断最新完成页面是哪一页. 来判断进入页面是否 需要调取 详情接口
       */
      updateFlowStep() {
        const flowStep = this.getStepData("flowStep")["flowStep"]
        const bdoStep = this.getBdoStep()
        // 返回后提交,不需要更新 flowStep;   flowStep 记录保存已提交的最大一步
        if (this.sliceBdoStep(flowStep) < this.sliceBdoStep(bdoStep)) {
          this.updateStepData({ flowStep: bdoStep }, "flowStep")
        }

      },

      /**
       *
       * @param bdostep 传入 bdostep "2-2-14"
       * @returns {number}  返回 14
       */
      sliceBdoStep(bdostep) {
        if (bdostep) {
          return parseInt(bdostep.split('-').slice(-1))
        } else {
          return 0
        }

      },
      /**
       * 新增编辑完成 路由跳转
       * @param 传进要 跳转的路由
       */
      routerChange(params) {
        //来自 总详情, 直接跳回
        if (this.fromSummary) {
          this.$router.go(-1)
        } else {
          this.toNext(params)
        }
      },

      /**
       *  判断上传图片是否符合类型, 大小
       * @param file
       * @returns {boolean|boolean}
       */
      beforeImgUpload(file) {
        let type = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
        const isJPG = type.indexOf(file.type) > -1;
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isJPG) {
            this.showMessageTip('File must be in JPG, JPEG, PNG, or PDF format');
        }
        if (!isLt2M) {
            this.showMessageTip('File must be smaller than 10MB');
        }
        return isJPG && isLt2M;
      },

      /**
       * 上传图片
       * @param res file文件
       * @param type 上传类型
       * @param exceedNumber 限制数量
       * @param list 已上传的列表
       */
      uploadImgSuccess(res, type, onceUploadNumber, exceedNumber, list = []) {
        this.onceUploadTime += 1;
        const allLength = list ? list.length + this.onceUploadTime : this.onceUploadTime;
        // 多选超过阻止
        if(exceedNumber && type === 'multiple' && allLength > exceedNumber) {
            this.showMessageTip(`You've reached the upload limit of ${exceedNumber} files`);
            return;
        }
        if(this.onceUploadTime > onceUploadNumber) {
            this.showMessageTip(`You've reached the upload limit of ${onceUploadNumber} files at one time`);
            return;
        }

        this.uploadingNumber += 1;
        loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.8)' })

        const formData = new FormData()
        formData.append('accessory', res.file)
        API.uploadPic(formData)
          .then((res) => {
            if (res.success) {
                if(type === 'simple') {
                    this.imgData = res.obj;
                } else {
                    this.imgList.push(res.obj);
                }
            }
            this.uploadingNumber -= 1;
            console.log('this.uploadingNumber:', this.uploadingNumber);
            if(this.uploadingNumber <= 0) {
              loadingInstance.close();
            }
            this.$emit("upload-success", res)
          })
          .catch(() => {
            this.uploadingNumber -= 1;
            console.log('this.uploadingNumber:catch', this.uploadingNumber);
            if(this.uploadingNumber <= 0) {
              loadingInstance.close();
            }
          })
      },

      /**
       *  上传超出回调
       * @param files 文件
       * @param onceUploadNumber 最大文件数
       */
      uploadFileExceed(files, imgList, onceUploadNumber = 5, exceedNumber = 5) {
        let length = 0;
        if(files.length > 0) length += files.length;
        if(Array.isArray(imgList)) length += imgList.length;
        if(files.length > onceUploadNumber) {
          this.showMessageTip(`You've reached the upload limit of ${onceUploadNumber} files at one time`);
          return;
        }
        if(length > exceedNumber) {
          this.showMessageTip(`You've reached the upload limit of ${exceedNumber} files`);
        }
      },

      /**
       * 获取文件名称
       * @param url 文件路径
       */
      getFileName(url) {
        if(url) {
            const arr = url.split('/');
            const fileName = arr[arr.length - 1];
            return fileName;
        }
        return '';
      },

      /**
       *
       * @param res 新窗口打开文件
       */
      openFile(url) {
        let hrefUrl = url;
        if(url.endsWith('.pdf')) {
          hrefUrl = `${location.origin}${location.pathname}/#/view-pdf?url=${encodeURIComponent(url)}`;
        }
        console.log('hrefUrl', hrefUrl);
        // 检测用户代理
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        // 对于iOS
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            const a = document.createElement('a');
            a.href = hrefUrl;
            a.target = '_blank';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        // 对于Android
        } else {
            window.open(hrefUrl, '_blank');
        }
      },

      /**
       *  用于 获取对应页面 bdostep, 准确跳转页面
       * @param processNo
       * @param pageNo
       * @returns {*}  返回遍历到的key值
       */
      checkProcess(processNo, pageNo) {
        let bdoStep = Object.keys(bdoStepRaw).reduce((acc, item) => {
          if (bdoStepRaw[item]["processNo"] == processNo && bdoStepRaw[item]["pageNo"] == pageNo) {
            acc["bdoStep"] = item
          }
          return acc
        }, {})

        return bdoStep
      },

      //acrNumber 校验规则
      addAcrNumberRules() {
        this.formRules["acrNumber"].push({
          // eslint-disable-next-line
          validator: (rule, value, callback) => {
            console.log({ "243": this.formData })
            if (this.formData.citizenship === "2") {
              if (value === "") {
                callback(new Error(`${allFields["acrNumber"]["labelTxt"]} is error`));
              } else {
                callback();
              }
            } else {
              callback();
            }

          },
          message: `${allFields["acrNumber"]["labelTxt"]} is error`,
          trigger: ['blur', 'change'] // 更改校验配置项
        })
      },

      //tinNumber 校验规则
      tinNumberRules() {
        this.formRules["tinNumber"].push({
          // eslint-disable-next-line
          validator: (rule, value, callback) => {
            if (!this.formData.tinStatus) {
              if (value === "" || !/^[0-9]*$/.test(value)) {
                callback(new Error(`${allFields["tinNumber"]["labelTxt"]} is error`));
              } else {
                callback();
              }
            } else {
              callback();
            }

          },
          trigger: ['blur', 'change'] // 更改校验配置项
        })
      },
      // 设置cookie参数
      setCookieItem: function () {
        return CookieHelper.setItem.apply(CookieHelper, arguments);
      },
      // 获取cookie参数
      getCookieItem: function () {
        return CookieHelper.getItem.apply(CookieHelper, arguments);
      },
      // 格式话提交数据
      formatCommitData(data) {
        const { pageNo = '', fieldWrapper = 'fieldWrapper' } = BdoProcessMap[this.$options.name];

        return {
          token: this.getCookieItem('token'),
          pageNo,
          [fieldWrapper]: data,
        }
      },
      // 获取列标题
      getColumHeader(column) {
        const headerMap = {
          businessOnlineStore: {
            type: "title",
            name: "",
            value: "Online Store Details",
          },
          digitalPayment: {
            type: 'title',
            name: '',
            value: 'Digital Payment Solutions',
          },
          physicalPayment: {
            type: 'title',
            name: '',
            value: 'Physical Payment Solutions',
          },
          homeAddress: {
            type: 'title',
            name: '',
            value: 'Home Address',
          },
          additionalDetails: {
            type: 'title',
            name: '',
            value: 'Additional Details',
          },
          businessDetails: {
            type: 'title',
            name: '',
            value: 'Business Details',
          },
          businessAddress: {
            type: 'title',
            name: '',
            value: 'Business Address',
          },
          businessOwnership: {
            type: 'title',
            name: '',
            value: '',
          },
          businessauthorizedSignatories: {
            type: 'title',
            name: '',
            value: '',
          },
          settlementAccount: {
            type: 'title',
            name: '',
            value: 'Settlement Account',
          },
          selfieWithIDPhoto: {
            type: 'title',
            name: '',
            value: 'Selfie with ID',
          },
          dtiPhoto: {
            type: 'title',
            name: '',
            value: 'DTI Photo',
          },
          secPhoto: {
            type: 'title',
            name: '',
            value: 'SEC Photo',
          },
          storePhoto: {
            type: 'title',
            name: '',
            value: 'Store Photo',
          },
          bdoBusinessDetails: {
            type: 'title',
            name: '',
            value: 'BDO Business Details',
          },
          personalInfo: {
            type: 'title',
            name: '',
            value: 'Personal Details',
          },
          personalInfo2: {
            type: 'title',
            name: '',
            value: 'Personal Details',
          },
          email: {
            type: 'title',
            name: '',
            value: '',
          }
        }
        return headerMap[column] || {};
      },
      // 格式化列数据
      formatColumn() {

        this.sections.forEach((item, index) => {
          const isDocument = item.editEntry === '/edit-document';
          const isSettlement = item.editEntry === '/edit-settlement';
          const [left, middle, right] = item.columns;
          const {
            selfieWithIDPhoto,
            secPhoto,
            dtiPhoto,
            storePhoto,
          } = this.formData

          if (isDocument) {
            this.sections[index].data['selfie'] = selfieWithIDPhoto ? this.getPhotoList('selfieWithIDPhoto') : [];
            // Document Submission下的勾选的所有枚举
            this.sections[index].isEditList = ['Selfie with ID','DTI Certificate',"Exterior","Interior",'Photo of DTI Certificate', 'Photo of SEC Certificate']
            if (secPhoto) {
              this.sections[index].data['certificate'] = secPhoto ? this.getPhotoList('secPhoto') : [];
            } else {
              this.sections[index].data['certificate'] = dtiPhoto ? this.getPhotoList('dtiPhoto') : [];
            }
            this.sections[index].data['exterior'] = storePhoto ? this.getPhotoList('exterior') : [];
            this.sections[index].data['interior'] = storePhoto ? this.getPhotoList('interior') : [];
          } else {
            this.sections[index].data['left'] = left ? this.getColumnList(left) : [];
            this.sections[index].data['middle'] = middle ? this.getColumnList(middle) : [];
            this.sections[index].data['right'] = right ? this.getColumnList(right) : [];
          }
          // BDO Settlement Account下的勾选的所有枚举
          if(isSettlement){
            this.sections[index].isEditList = ['Bank', 'Account Name', 'Account Number']
          }

        })
        console.log(this.sections)
      },
      // 获取列数据
      getColumnList(column) {
        let columnData = ''
        let columnKeys = ''
        if (['personalInfo2','personalInfo3','email','email2'].includes(column)) {
          columnKeys = Object.keys('personalInfo')
          columnData = this.formData['personalInfo']
        } else {
          columnKeys = Object.keys(columnData)
          columnData = this.formData[column]
        }

        const fieldHandler = {
          digitalPayment() {

            return columnData['digitalPaymentList'].map((item) => {

              return {
                type: 'nomal',
                name: item.productName,
                value: item.chooseFlag === '1' ? 'YES' : 'NO',
              }
            })
          },
          physicalPayment() {

            return columnData['physicalPaymentList'].map((item) => {

              return {
                type: 'nomal',
                name: item.productName,
                value: item.chooseFlag === '1' ? 'YES' : 'NO',
              }
            })
          },
          businessAddress() {
            const province = provinceData.filter(val => val.value == columnData.province)[0].label
            const city = cityData[columnData.province].filter(val => val.value == columnData.city)[0].label
            const barangay = barangayData[columnData.city].filter(val => val.value == columnData.barangay)[0].label
            return [{
              type: 'nomal',
              name: 'Business Address',
              value: `${!columnData.streetAddress ? '' : columnData.streetAddress + ',' }${!columnData.subdivision ? '' : columnData.subdivision + ','}`,
            }, {
              type: 'nomal',
              name: '',
              value: `${barangay},${city},`,
            }, {
              type: 'nomal',
              name: '',
              value: `${province} ${columnData.zipCode}`,
            }]
          },
          homeAddress() {
            const province = provinceData.filter(val => val.value == columnData.province)[0].label
            const city = cityData[columnData.province].filter(val => val.value == columnData.city)[0].label
            const barangay = barangayData[columnData.city].filter(val => val.value == columnData.barangay)[0].label
            return [{
              type: 'nomal',
              name: 'Home Address',
              value: `${!columnData.streetAddress ? '' : columnData.streetAddress + ',' }${!columnData.subdivision ? '' : columnData.subdivision + ','}`,
            }, {
              type: 'nomal',
              name: '',
              value: `${barangay},${city},`,
            }, {
              type: 'nomal',
              name: '',
              value: `${province}  ${columnData.zipCode}`,
            }]
          },
          additionalDetails() {
            const monthSelectData = {
              '1': 'January',
              '2': 'February',
              '3': 'March',
              '4': 'April',
              '5': 'May',
              '6': 'June',
              '7': 'July',
              '8': 'August',
              '9': 'September',
              '10': 'October',
              '11': 'November',
              '12': 'December',
            }
            return [{
              type: 'nomal',
              name: 'Date of Birth',
              value: `${monthSelectData[columnData.month]} ${columnData.day}, ${columnData.year}`,
            }, {
              type: 'nomal',
              name: 'Country of Birth',
              value: columnData.countryOfBirth,
            },
            {
              type: 'nomal',
              name: 'City of Birth',
              value: columnData.cityOfBirth,
            },
            {
              type: 'nomal',
              name: 'Citizenship',
              value: citizenShipOptions.filter(val => val.value == columnData.citizenship)[0].label,
            }, {
              type: 'nomal',
              name: 'TIN',
              value: columnData.tin,
            }]
          },
          personalInfo() {
            return [{
              type: 'nomal',
              name: 'Full Name',
              value: `${columnData.firstName} ${columnData.middleName || ''} ${columnData.lastName} ${columnData.suffix || ''}`,
            }, {
              type: 'nomal',
              name: 'Mobile Number',
              value: columnData.mobile,
            },
            {
              type: 'nomal',
              name: 'Email Address',
              value: columnData.email,
            }]
          },
          personalInfo2() {
            return [{
              type: 'nomal',
              name: 'Full Name',
              value: `${columnData.firstName} ${columnData.middleName || ''} ${columnData.lastName} ${columnData.suffix || ''}`,
            }, {
              type: 'nomal',
              name: 'Mobile Number',
              value: columnData.mobile,
            }]
          },
          personalInfo3() {
            return [{
              type: 'nomal',
              name: 'Full Name',
              value: `${columnData.firstName} ${columnData.middleName || ''} ${columnData.lastName} ${columnData.suffix || ''}`,
            }, {
              type: 'nomal',
              name: 'Mobile Number',
              value: columnData.mobile,
            }]
          },
          email() {
            return [
              {
                type: 'nomal',
                name: 'Email Address',
                value: columnData.email,
            }]
          },
          email2() {
            return [
              {
                type: 'nomal',
                name: 'Email Address',
                value: columnData.email,
            }]
          },
          settlementAccount(){
            let BankType = ""
            switch (columnData.bankType) {
              case "1":
                BankType = "BDO Unibank"
                break;
              case "2":
                BankType = "BDO Network Bank"
                break;
              case "3":
                BankType = ""
                break;
            }
            return [{
              type: 'nomal',
              name: 'Bank',
              value: BankType,
            }, {
              type: 'documents',
            },
            {
              type: 'nomal',
              name: 'Account Name',
              value: columnData.accountName,
            },
            {
              type: 'nomal',
              name: 'Account Number',
              value: columnData.accountNumber,
            }]
          },
          businessOnlineStore() {

            return columnData['onlineStoreList'].reduce((acc, item) => {

              acc.push({
                type: 'nomal',
                name: 'Marketplace or Social Media',
                value: item.socialMedia,
              }, {
                type: 'wrap',
                name: 'Profile Name or URL',
                value: item.url,
              })
              return acc;
            }, [])
          },
          businessDetails() {
            let MerchantType = ""
            switch (columnData.processNo) {
              case "1":
                MerchantType = "Individual"
                break;
              case "2":
                MerchantType = "Sole Proprietorship"
                break;
              case "3":
                MerchantType = "Corporation "
                break;
              case "4":
                MerchantType = "Partnership"
                break;
            }
            return [{
              type: 'nomal',
              name: 'Type of Merchant',
              value: MerchantType,
            }, {
              type: 'documents',
            },
            {
              type: 'nomal',
              name: 'Business Name',
              value: columnData.businessName,
            },
            {
              type: 'wrap',
              name: 'Business Description',
              value: columnData.businessDescription,
            }]
          },
          common() {

            return columnKeys.map(item => {

              return {
                type: 'nomal',
                name: fieldsInfo[item] && fieldsInfo[item].labelTxt || item,
                value: columnData[item],
              }
            })
          }
        }

        return [
          this.getColumHeader(column),
          ...(fieldHandler[column] || fieldHandler['common'])()
        ];
      },
      // 获取图列表
      getPhotoList(photoType) {
        const photoData = this.formData[photoType] || {}
        const storePhoto = this.formData['storePhoto'] || {}
        const photoListHander = {
          selfieWithIDPhoto: {
            title: "Selfie with ID",
            name: "Selfie with ID",
            imgurl: photoData.idCardiUrl || "",
          },
          secPhoto: {
            title: "SEC Certificate",
            name: "Photo of SEC Certificate",
            imgurl: photoData.secUrl || "",
          },
          dtiPhoto: {
            title: "DTI Certificate",
            name: "Photo of DTI Certificate",
            imgurl: photoData.dtiUrl || "",
          },
          exterior: {
            title: "Store Photo",
            name: "Exterior",
            imgurl: storePhoto.exterior && storePhoto.exterior,
          },
          interior: {
            title: "",
            name: "Interior",
            imgurl: storePhoto.interior && storePhoto.interior,
          },
        }


        return photoListHander[photoType] || {};
      },
    }
  })
};
